import { render, staticRenderFns } from "./StatusSolicitacaoSelect.vue?vue&type=template&id=130271a8&"
import script from "./StatusSolicitacaoSelect.vue?vue&type=script&lang=js&"
export * from "./StatusSolicitacaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports